import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";

import Notification from "../other/Notification";
import OrderCountDashboard from "./OrderCountDashboard";
import SalesGraphDashboard from "./SalesGraphDashboard";
import SalesPieChartDashboard from "./SalesPieChartDashboard";
import PaymentStatusPieChart from "./PaymentStatusPieChart";
import CancelPieChartDashboard from "./CancelStatusPieChart";
import OrderTypePieChartDashboard from "./OrderTypePieChart";



const Dashboard = () => {

  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);


  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>

              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="dashboard" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">

                      <div className="home-tab">

                        <div className="tab-content tab-content-basic">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview"
                          >
                            <OrderCountDashboard token={token} />

                            <br />
                            <div className="row">
                              <div className="col-lg-12 d-flex flex-column">
                                <SalesGraphDashboard token={token} />

                              </div>



                            </div>
                            <br />

                            <div className="row">
                              <div className="col-lg-3 d-flex flex-column">
                                <SalesPieChartDashboard token={token} />
                              </div>

                              <div className="col-lg-3 d-flex flex-column">
                                <PaymentStatusPieChart token={token} />
                              </div>

                              <div className="col-lg-3 d-flex flex-column">
                                <OrderTypePieChartDashboard token={token} />
                              </div>

                              <div className="col-lg-3 d-flex flex-column">
                                <CancelPieChartDashboard token={token} />
                              </div>
                            </div>





                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <Notification />
        </>
      )}
    </>
  );
};

export default Dashboard;
